import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import Swal from 'sweetalert2';
import { DirtyComponent } from 'projects/shared/src/helpers/CanDeactivate/dirty-component';
import { Lookup } from 'projects/shared/src/models/lookup';
import { Action } from '../../../models/fraud-monitoring-tasks/AvailableActions';
import { FraudTaskService } from '../../../services/fraud-task.service';
import { TaskActionData } from '../../../models/fraud-monitoring-tasks/TaskActionData';

export interface DialogData {
  action: Action;
  taskId: number
}


@Component({
  selector: 'app-fraud-confirm-escalation',
  standalone: false,
  templateUrl: './fraud-confirm-escalation.component.html'
})
export class FraudConfirmEscalationComponent extends DirtyComponent implements OnInit {
  dataLoading = false;
  loading = false;
  override formGroup: FormGroup = new FormGroup({});
  institutionList: Lookup[] = [];

  constructor(
    override dialogRef: MatDialogRef<FraudConfirmEscalationComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private formBuilder: FormBuilder,
    private service: FraudTaskService,
    translate: TranslateService
  ) {
    super(translate);
  }

  ngOnInit(): void {
    this.buildForm();
    this.getInstitutionsToEscalate();
  }

  getInstitutionsToEscalate() {
    this.dataLoading = true;
    this.service.getInstitutionsToEscalate(this.data.taskId).subscribe(
      (data: any) => {
        this.dataLoading = false;
        this.institutionList = data as Lookup[];
      }, (err: any) => {
        this.dataLoading = false;
      });
  }

  buildForm() {
    this.formGroup = this.formBuilder.group({
      institutionId: [null, Validators.required],
      reason: [null],
    });
  }

  saveRecord() {
    if (this.formGroup.valid) {
      this.loading = true;
      const data = {
        actionId: this.data.action.actionId,
        taskId: this.data.taskId,
        nextStatus: this.data.action.nextStatus,
        institutionId: this.formGroup.controls['institutionId'].value,
        reason: this.formGroup.controls['reason'].value
      } as TaskActionData;
      this.service.changeTaskStatus(data).subscribe((res: any) => {
        this.loading = false;
        this.dialogRef.close(true);
        Swal.fire({
          title: this.translate.instant('swalMsg.fraudCaseEscalatedSuccessfully'),
          // text: this.translate.instant('verificationTasks.escalationEmailSentSuccessfully'),
          imageUrl: './assets/images/icons/success.svg',
          confirmButtonText: this.translate.instant('swalMsg.Ok'),
        });
      }, (error: any) => {
        this.loading = false;
      });
    } else {
      this.formGroup.markAllAsTouched();
    }
  }

  hasError(controlName: string, errorName: string) {
    return this.formGroup.controls[controlName].hasError(errorName);
  }
}
